import { useContext, useEffect } from 'react'

import {
  Box,
  DoughnutChart,
  getThemeColor,
  Text,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { themeColors } from '../../../../utilities/colors/themeColors'
import { ProvidersContext } from '../../providers.context'
import { ProviderCard } from '../ProviderCard/providers-card.comp'

import * as Styles from './providers-cards.styles'
export const ProviderCards = () => {
  const {
    providersCount,
    activeProviders,
    inactiveProviders,
    riskProviders,
    providersWithInvoices,
    providersWithCertificates,
    actions,
  } = useContext(ProvidersContext)

  const theme = useTheme()

  useEffect(() => {
    actions.getProvidersStatistics()
  }, [])

  return providersCount ? (
    <Box
      width="100%"
      borderRadius={theme.border_radius.table}
      boxShadow={theme.box_shadow.card}
      backgroundColor={theme.colors.custom.white}
      padding={3}
      gap={2}
      flexWrap="wrap"
      alignItems="stretch"
    >
      <Box
        boxShadow={theme.box_shadow.card}
        borderRadius={theme.border_radius.card}
        border={{
          width: 1,
          color: 'grey_5',
        }}
        padding={3}
        gap={2}
        alignItems="stretch"
        justifyContent="center"
        flex={1}
        flexWrap="wrap"
        maxWidth="370px"
      >
        <DoughnutChart
          size={90}
          totalValue={providersCount}
          parts={[
            { value: activeProviders, color: theme.colors.primary },
            { value: inactiveProviders, color: theme.colors.secondary },
          ]}
          fontSize="20px"
        />
        <Box direction="column" justifyContent="center">
          <Box alignItems="center" gap={1}>
            <Box
              borderRadius="50%"
              backgroundColor="primary"
              height="8px"
              width="8px"
            />
            <Text size="small">Fornecedores ativos</Text>
            <Text size="medium" fontWeight={500}>
              {activeProviders}
            </Text>
          </Box>

          <Box alignItems="center" gap={1}>
            <Box
              borderRadius="50%"
              backgroundColor="secondary"
              height="8px"
              width="8px"
            />
            <Text size="small">Fornecedores inativos</Text>
            <Text fontWeight={500} size="medium">
              {inactiveProviders}
            </Text>
          </Box>
        </Box>
      </Box>

      <ProviderCard
        color="purple"
        icon="receipt"
        title="Fornecedores com NFs"
        value={providersWithInvoices}
      />
      <Styles.Link
        href="#providerTable"
        onClick={() => {
          actions.setCheckboxRisksFilter(true)
        }}
      >
        <ProviderCard
          color="warning"
          title="Riscos Socioambientais"
          value={riskProviders}
        />
      </Styles.Link>
      <Box
        boxShadow={theme.box_shadow.card}
        borderRadius={theme.border_radius.card}
        border={{
          width: 1,
          color: 'grey_5',
        }}
        padding={3}
        gap={2}
        alignItems="stretch"
        justifyContent="center"
        flex={1}
        flexWrap="wrap"
        maxWidth="370px"
      >
        <DoughnutChart
          size={90}
          totalValue={100}
          showTotalValue={false}
          showTooltip
          tooltipValueFormatter={(value) => `${value}%`}
          parts={[
            ...providersWithCertificates.map((certificate, index) => ({
              value: parseFloat(
                (
                  (parseInt(certificate.count?.toString() ?? '0') /
                    providersCount) *
                  100
                ).toFixed(1),
              ),
              color: getThemeColor(
                themeColors[index % themeColors.length],
                theme,
              ),
              name: `${certificate.type.toUpperCase()}`,
            })),
            {
              value: parseFloat(
                (
                  ((providersCount -
                    providersWithCertificates.reduce(
                      (acc, certificate) => acc + certificate.count,
                      0,
                    )) /
                    providersCount) *
                  100
                ).toFixed(1),
              ),
              color: getThemeColor('grey_5', theme),
              name: 'Sem certificados',
            },
          ]}
          fontSize="20px"
        />
        <Box direction="column" justifyContent="center">
          {providersWithCertificates.length > 0 && (
            <>
              {providersWithCertificates.map((certificate, index) => (
                <Box key={index} alignItems="center" gap={1}>
                  <Box
                    borderRadius="50%"
                    backgroundColor={getThemeColor(
                      themeColors[index % themeColors.length],
                      theme,
                    )}
                    height="8px"
                    width="8px"
                  />
                  <Text size="small">{certificate.type.toUpperCase()}</Text>
                  <Text fontWeight={500} size="medium">
                    {certificate.count}
                  </Text>
                </Box>
              ))}
            </>
          )}

          <Box alignItems="center" gap={1}>
            <Box
              borderRadius="50%"
              backgroundColor="grey_4"
              height="8px"
              width="8px"
            />
            <Text size="small">Sem certificados</Text>
            <Text fontWeight={500} size="medium">
              {providersCount -
                providersWithCertificates.reduce(
                  (acc, certificate) => acc + certificate.count,
                  0,
                )}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  ) : null
}
